module.exports = __webpack_public_path__ + "static/media/landing-background.22b7acf6.jpg";